import { Capacitor } from "@capacitor/core";

/**
 * Platform-aware session token storage.
 *
 * WEB: the token is NEVER persisted — the same-origin HttpOnly cookie set by
 * the backend is the only credential, so XSS cannot exfiltrate the session.
 *
 * NATIVE (Capacitor iOS/Android): the WebView origin (capacitor://localhost)
 * is cross-origin to the API, where cookies are unreliable, so the Bearer
 * token is kept in the OS secure store (iOS Keychain / Android Keystore).
 */
export const isNative = Capacitor.isNativePlatform();

const TOKEN_KEY = "session_token";
let _storagePromise = null;

const secureStorage = () => {
  if (!_storagePromise) {
    _storagePromise = import("@aparajita/capacitor-secure-storage").then(
      (m) => m.SecureStorage
    );
  }
  return _storagePromise;
};

export async function getToken() {
  if (!isNative) return null;
  try {
    const ss = await secureStorage();
    const value = await ss.get(TOKEN_KEY);
    return value || null;
  } catch {
    return null;
  }
}

export async function setToken(token) {
  if (!isNative || !token) return;
  try {
    const ss = await secureStorage();
    await ss.set(TOKEN_KEY, token);
  } catch (e) {
    console.warn("Secure storage set failed:", e?.message || e);
  }
}

export async function clearToken() {
  if (!isNative) return;
  try {
    const ss = await secureStorage();
    await ss.remove(TOKEN_KEY);
  } catch (e) {
    console.debug("Secure storage remove failed:", e?.message || e);
  }
}
